<template lang="pug">
div(class="flex items-center relative profiles__search-container")
  input(:placeholder="label || $t('search')", v-model="childValue", class="bg-gray-1 rounded border border-gray-2 input-wrap mr-2 w-full", @input="$emit('input')", data-qa="step0-search-input")
  svg(xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" v-if="childValue" @click="$emit('update:modelValue', '') || $emit('input')", data-qa="step0-search-clear")
    path(d="M18 6L6 18M6 6L18 18" stroke="#75828B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round")
</template>
<script>
export default {
  name: 'SearchNew',
  props: {
    modelValue: String,
    label: {
      type: String,
      default: '',
    },
  },
  computed: {
    childValue: {
      get() {
        return this.modelValue
      },

      set(setterValue) {
        this.$emit('update:modelValue', setterValue)
      },
    },
  },
}
</script>
<style>
.search {
  position: relative;
}

.search input {
  -webkit-appearance: none !important;
  appearance: none !important;
}

.direction--rtl {
  .search input {
    padding-right: 35px;
    margin: 0 0 0 8px;
  }
}

.search input::-webkit-search-cancel-button {
  transform: translateX(-1.8rem);
}

.search svg {
  position: absolute;
  right: 8px;
  top: 52%;
  transform: translateY(-50%);
  opacity: 0.7;
  cursor: pointer;
}
</style>
